import React from 'react';
import { Wrapper } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { TextLoading } from '../../../../CommonComponents/OPL/Text/Text.loading';

export const ExplanationsLoading: React.FC = () => {
  return (
    <Wrapper my="24">
      <TextLoading height="h3" width={250} />
      <TextLoading width={450} mt="16" />
    </Wrapper>
  );
};
